import React, { useMemo, useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert,Spinner, Container, Form, Input, FormFeedback, Label ,FormGroup, Button, CardTitle, Modal, ModalHeader, ModalBody} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import Select from 'react-select'
import axios from '../../axios';
import moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import Numeral from 'react-numeral';
import FileSaver from 'file-saver'
import Xl from 'excel4node'

import { Backdrop, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display:'flex',
    flexDirection:'column',
  
  },
}));

function PO_Status() {

    const [companyhelp,setcompanyhelp]=useState([])
    const [Companyvalue, setCompanyvalue] = useState({})
    const [buyerhelp,setbuyerhelp]=useState([])
    const [buyervalue,setbuyervalue]=useState({label:"All",value:"0"})
    const [stylehelp,setstylehelp]=useState([])
    const [stylevalue,setstylevalue]=useState({label:"All",value:"All"})
    const [ordertypevalue,setordertypevalue]=useState({label:"All",value:"All"})
    const [fromdate, setfromdate] = useState(new Date())
    const [todate, settodate] = useState(new Date())
    const [po_statusdata,setpo_statusdata]=useState([])
    const [po_statusNull, setpo_statusNull] = useState(false)
    const [purchaseStatusView, setpurchaseStatusView] = useState()
    const [modal, setModals] = useState(false);
    const toggle = () => setModals(!modal);
    const [po_header, setpo_header] = useState([])
    const [po_fabric, setpo_fabric] = useState([])
    const [po_trim, setpo_trim] = useState([])
    const [fabtotal, setfabtotal] = useState(0)
    const [trimtotal, settrimtotal] = useState(0)

    //showtable
    const [showtabel, setshowtabel] = useState(false)

    const classes = useStyles();
    const [Spinner1, setSpinner1] = useState(false)

    useEffect(() => {
        company()
        buyer()

        var date =  new Date()
      
        var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
       
        var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        setfromdate(moment(firstday).format('YYYY-MM-DD'))
        settodate(moment(lastday).format('YYYY-MM-DD'))
        setCompanyvalue(JSON.parse(localStorage.getItem('company')))
        console.log(Companyvalue,"value")
        console.log(JSON.parse(localStorage.getItem('company')),"json")
    }, [])


    const Ordertypeoption=[
        {label:"Bulk",value:"Bulk"},
        {label:"Sample",value:"Sample"},
        {label:"All",value:"All"}
    ]
    

    const company=async()=>{
        await axios.instance.get("CompanyHelp/GetCompany")
        .then((res)=>{
            const data=res.data
            const option=data.map(row=>({
                "label":row.company,
                "value":row.companyId
            }))
            console.log(option,"companyhelp");
            setcompanyhelp(option)  
        }) 
    }

    const buyer=async()=>{
        await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
        .then((res)=>{
            const data =res.data
            const option=data.map(row=>({
                "label":row.buyer,
                "value":row.buyerId
            }))
            option.push({"label":"All",
            "value":"0"})
            setbuyerhelp(option)
        })
    }

    const style=async(value)=>{
        await axios.instance.get(`/StyleNoHelp/BookedOrderStyleHelp?buyerid=${value}`)
        .then((res)=>{
            const data =res.data
            // console.log(res.data)
            const option=data.map(row=>({
                "label":row.style,
                 "value":row.style
            }))
            console.log(option,"stylehelp")
            option.push({label:"All",value:"All"})
            setstylehelp(option)
        })
    }

    const po_statusAllData=async()=>{
        setshowtabel(true)
        setSpinner1(true)
        await axios.instance.get(`PO_Status?buyerId=${buyervalue.value}&style=${stylevalue.value}&OrderType=${ordertypevalue.value}&startDate=${fromdate}&endDate=${todate}&companyid=${Companyvalue.value}`)
        .then((res)=>{
            console.log(res.data,'gdfqshgdqhgf') 
            res.data == '' ? (setpo_statusdata([]) || setpo_statusNull(true)) :  setpo_statusdata(res.data)
        }) 
        setTimeout(() => {
            setSpinner1(false)
          }, 2000);
          handleDownload()
    }


    const po_statustoExel = () => {
        let po_statustoExeldata = []
        const columns = [
            'Buyer',
            'IPO No',
            'Style',
            'Order No',
            'Order Date',
            'Order Quantity',
            'Ship Date',
            'Garment Description',
            'Season',
            'Ship Mode',
            'Fabric PO',
            'Trim PO'
        ]

        po_statusdata.map((data) => {
            // console.log(data)
            po_statustoExeldata.push({
                "Buyer":data.buyer,
                "IPONo":data.i.toString(),
                "Style":data.style,
                "OrderNo":data.orderNo,
                "OrderDate":data.orderDt,
                "OrderQuantity":data.qty.toString(),
                "ShipDate":data.shipDt,
                "GarmentDescription":data.garment,
                "Season":data.season,
                "ShipMode":data.shipMode,
                'Fabric PO':data.fabStatus == "Y" ? 'Rasied' :  'Not Raised',
                'Trim PO':data.trimStatus == "Y" ? 'Rasied' :  'Not Raised',
            })
        })
   

        const wb = new Xl.Workbook();
        const ws = wb.addWorksheet('PO Status'); 
        var headings = wb.createStyle({
            font: {
                bold: true,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: '#ddd9c3'
            }
        });

        var heading1 = wb.createStyle({
            font: {
                bold: false,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal: 'left',
                vertical: 'center',
                wrapText: true
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            }
        })

        var heading2 = wb.createStyle({
            font: {
                bold: false,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal: 'right',
                vertical: 'center',
                wrapText: true
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            }
        })

        let headingColumnIndex = 1;
            columns.forEach(heading => {
                ws.column(headingColumnIndex).setWidth(30);
            ws.cell(7, headingColumnIndex++)
                .string(heading).style(headings)
        }); 

        let rowIndex = 8;
        po_statustoExeldata.forEach( record => {
            let columnIndex = 1;
            Object.keys(record ).forEach(columnName =>{
            //   console.log(columnName)
            ws.column(columnIndex).setWidth(30);

            columnIndex === 2 || columnIndex === 4 || columnIndex === 6 ? 
                ws.cell(rowIndex,columnIndex).style(heading2) : 
                ws.cell(rowIndex,columnIndex).style(heading1) 

                ws.cell(rowIndex,columnIndex++)
                    .string(record [columnName])
            });
            rowIndex++;
        });

        ws.row(7).freeze()

        ws.cell(1, 1, 1, 15, true).string('IPONO Wise PO Status').style(headings);

        ws.cell(3, 1).string('Company').style(headings);
        ws.cell(3, 2).string(Companyvalue.label).style(headings);

        ws.cell(3, 4).string('Buyer').style(headings);
        ws.cell(3, 5).string(buyervalue.label).style(headings);

        ws.cell(3, 7).string('Style No').style(headings);
        ws.cell(3, 8).string(stylevalue.label).style(headings);

        ws.cell(5, 1).string('Order Type').style(headings);
        ws.cell(5, 2).string(ordertypevalue.label).style(headings);
        
        ws.cell(5, 4).string('From Date').style(headings);
        ws.cell(5, 5).string(moment(fromdate).format("DD-MM-yyyy")).style(headings);

        ws.cell(5, 7).string('To Date').style(headings);
        ws.cell(5, 8).string(moment(todate).format("DD-MM-yyyy")).style(headings);    

        wb.writeToBuffer().then(function(buffer) {
            //console.log(buffer)
            const data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
            //console.log(datas)
            FileSaver.saveAs(data,  'PO_Status' + ".xlsx")
        });
  

    }


    const viewdetils = async(arg)=>{

        setSpinner1(true)
        const detls = arg
        // setModals(true)
        
        toggle()

        // All PO_Status Summary Data
        await axios.instance.get(`/PO_Status/PO_StatusDetailHeader?orderid=${detls.orderId}`, 
            ).then((res) => {
                console.log(res.data)
                setpo_header(res.data)
        }
        )

        // PO_Status Detail Fabric Part Data
        await axios.instance.get(`/PO_Status/PO_StatusDetailFabric?orderid=${detls.orderId}`, 
            ).then((res) => {
                console.log(res.data)
                setpo_fabric(res.data)

                const temptot = [];
                for(let data of res.data){
                    temptot.push(data.amount)
                }

                let tot = 0
                for (let i=0; i<temptot.length;i++){
                    tot += temptot[i];
                }
                console.log(tot, 'total')
                setfabtotal(tot)
        })

        // PO_Status Detail Trim Part Data
        await axios.instance.get(`/PO_Status/PO_StatusDetailTrim?orderid=${detls.orderId}`, 
            ).then((res) => {
                console.log(res.data)
                setpo_trim(res.data)

                const temptot1 = [];
                for(let data of res.data){
                    temptot1.push(data.amount)
                }

                let tot1 = 0
                for (let i=0; i<temptot1.length;i++){
                    tot1 += temptot1[i];
                }
                console.log(tot1, 'total')
                settrimtotal(tot1)
        })
     setTimeout(() => {
            setSpinner1(false)
          }, 2000);
    }


    const column = useMemo(
        () => [
            {
                Header: "SNo",
                accessor: (row, index) => index + 1,
                disableFilters: true,
            },
          {
            Header: "Buyer",
            // accessor: (row=>(<div className='text-start'>{row.buyer}</div>)),
            accessor:'buyer',
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "IPO No",
          accessor: (row=>(<div className='text-end'>{row.i}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Style",
            accessor: (row=>(<div className='text-start'>{row.style}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Order No",
            accessor: (row=>(<div className='text-end'>{row.orderNo}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Order Date",
            accessor: (row=>(<div className='text-start'>{row.orderDt}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Order Quantity",
          accessor: (row=>(<div className='text-end'>{row.qty}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Ship Date",
          accessor: (row=>(<div className='text-start'>{row.shipDt}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Garment Description",
          accessor: (row=>(<div className='text-start'>{row.garment}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Season",
          accessor: (row=>(<div className='text-start'>{row.season}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Ship Mode",
          accessor: (row=>(<div className='text-start'>{row.shipMode}</div>)),
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Fabric PO",
            accessor: row=>row.fabStatus == "Y" ? <p className='text-start'>Raised</p> :  <p className='text-start' style={{backgroundColor:'yellow'}}>Not Raised</p>,
            filterable: false,
            disableFilters: true,
          },
          {
            Header: "Trim PO",
            accessor: row=>row.trimStatus == "Y" ? <p className='text-start'>Raised</p> : <p className='text-start' style={{backgroundColor:'yellow'}}>Not Raised</p>,
            filterable: false,
            disableFilters: true,
          },
        //   {
        //     Header: "Purchase_Status",
        //     // accessor: 'orderId',
        //     filterable: false,
        //     disableFilters:true,
        //     Cell:(cellProps)=>(
        //         <div className="d-flex gap-3" style={{textAlign:'center'}}>
        //             {/* <Link
        //                 to="#"
        //                 className="text-danger"
        //             > */}
        //                 <Button 
        //                     style={{backgroundColor:'#5b73e8',borderRadius:'45px' ,padding:'5px',fontSize:'11px',textAlign:'center' }} 
        //                     onClick={
        //                         ()=> {
        //                     // const purchase = cellProps.row.original
        //                     viewdetils(cellProps.row.original)} }
        //                 >View</Button>
        //             {/* </Link> */}
        //         </div>
        //       ),
        //   },
        {
            Header: "Purchase Status",
            accessor:cellProps => (
              <React.Fragment>
             <Button
              onClick={()=>{
                const users = cellProps 
                viewdetils(users)
                // handleUserClick(users)
              }}
            > View</Button>
             </React.Fragment>
            ),
            filterable: false,
            disableFilters: true,
          },	

                                                          

        ]
    )

    const handleDownload = async() => {
        const value =   await axios.instance.get(`/PO_Status/POStatusExcel?buyers=${buyervalue.label}&companys=${Companyvalue.label}&buyerId=${buyervalue.value}&style=${stylevalue.value}&OrderType=${ordertypevalue.value}&startDate=${moment(fromdate).format('YYYY-MM-DD')}&endDate=${moment(todate).format('YYYY-MM-DD')}&companyid=${Companyvalue.value}`, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                   // window.open(response.data, '_blank');
                
                   // const link = document.createElement('a');
                   // link.href = url;
                  //  link.setAttribute('download', 'PO_Status.xlsx');
                   // document.body.appendChild(link);
                  //  window.open(link)
                   // link.click();
     
                   
                })
               // window.open(value)
                .catch(error => {
                    console.error('Error downloading Excel file:', error);
                });
        };


        const ExporttoExcelConsolidate = async() => {
            // await  axios.instance.get('/GetDepartmentSalarySummary', { responseType: 'blob'})
                 
             // .then((res) => {
                // const xlBlob = new Blob([res.data] ,{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'})
                // FileSaver.saveAs(xlBlob , `${fileName}.xlsx`)
           //         localStorage.setItem('pdf', pdfBlob)
           //const value = BookedOrder;
          //  var date =  new Date()
        
        
           const now = new Date();
          const year = now.getFullYear();
          const month = now.toLocaleString('default', { month: 'long' });
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
         // const date =(`${month}_${day}_${year}`)
          const amPm = hours >= 12 ? 'PM' : 'AM';
          const date =(`${month}_${day}_${year}_${hours}_${minutes}_${amPm}`)
          await window.open(`http://103.27.85.36/ExcelFilewebmins/Po_Status_${date}.xlsx`)
          //await window.open(`http://192.168.1.2/Wbei/ExcelFile/PoStatus_${date}.xlsx`)
          
              // })
           }
           
  return (
    <React.Fragment>
    {/* <div className="container-fluid">
        <div className="card">
            <div className="card-body p-3 bg-white"> */}
      <div className="account-pages my-5 pt-5 m-3 pt-sm-5">
        <Container fluid={true}>
            <Card style={{backgroundColor:"white"}}>
                <CardBody className="p-4">
                    <Row>
                        <Col>
                            <Breadcrumb title="Report" breadcrumbItem="PO Status" />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm='12' md='6' lg='3'>
                            <FormGroup> 
                                <Label for='excompany'>
                                    Company
                                </Label>         
                                <Select 
                                    onChange={(value) => {
                                        // console.log(value.value)
                                        setCompanyvalue(value)
                                        // localStorage.setItem('company',JSON.stringify(value))
                                    }}
                                     value={Companyvalue}
                                    options={companyhelp}
                                    styles={{
                                        menuPortal: (provided, state) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        }),
                                        menu: (provided, state) => ({
                                        ...provided,
                                        height: 'auto',
                                        }),
                                    }}
                                    menuPortalTarget={document.body}
                                    
                                />
                            </FormGroup>
                        </Col>
                        <Col sm='12' md='6' lg='3'>
                            <FormGroup> 
                                <Label for='exbuyer'>
                                    Buyer
                                </Label>         
                                {/* <Input id='exbuyer' name='Buyer' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Buyer"
                                    value={buyervalue}
                                    onChange={(value)=>{
                                        // console.log(value.value,"buyervalue")
                                        setbuyervalue(value)
                                        style(value.value)
                                        // bookedorder(value.value)
                                        console.log(value.value,"stylevalue")
                                    }}
                                    options={buyerhelp}
                                    styles={{
                                        menuPortal: (provided, state) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        }),
                                        menu: (provided, state) => ({
                                        ...provided,
                                        height: 'auto',
                                        }),
                                    }}
                                    menuPortalTarget={document.body}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm='12' md='6' lg='3'>
                            <FormGroup> 
                                <Label for='exstyleno'>
                                    Style No
                                </Label>         
                                {/* <Input id='exstyleno' name='Style No' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Style No"
                                    value={stylevalue}
                                    onChange={(value)=>{
                                        console.log(value.value,"stylevalue")
                                        console.log(value.label,"stylelabel")
                                        setstylevalue(value) 
                                    }}
                                    options={stylehelp}
                                    styles={{
                                        menuPortal: (provided, state) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        }),
                                        menu: (provided, state) => ({
                                        ...provided,
                                        height: 'auto',
                                        }),
                                    }}
                                    menuPortalTarget={document.body}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm='12' md='6' lg='3'>
                            <FormGroup> 
                                <Label for='exordertype'>
                                    Order Type
                                </Label>         
                                {/* <Input id='exordertype' name=' Order Type' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Order Type" 
                                    id= 'exordertype'
                                    value={ordertypevalue}
                                    options={Ordertypeoption}
                                    onChange={(value)=>{
                                        console.log(value.value,"ordertypevalue")
                                        setordertypevalue(value)

                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm='12' md='6' lg='3'>
                            <FormGroup> 
                                <Label for='exfromdate'>
                                From Date
                                </Label>         
                                <Input id='exfromdate' name='Date' type='date' 
                                    value={fromdate}
                                    onChange={(e)=> setfromdate(e.target.value)}
                                    min="1900-01-01" maxLength='4' max="9999-12-31"
                                />
                            </FormGroup>
                        </Col>
                        <Col sm='12' md='6' lg='3'>
                            <FormGroup> 
                                <Label for='extodate'>
                                To Date
                                </Label>         
                                <Input id='extodate'
                                    onChange={(e)=> settodate(e.target.value)}
                                    min="1900-01-01" maxLength='4' max="9999-12-31"
                                    value={todate}
                                    name='ToDate' type='date' />
                            </FormGroup>
                        </Col>
                        <Col style={{marginTop:'30px',marginBottom:'10px'}} sm='12' md='6' lg='4'>
                            {/* <Button color='primary' size='md' className="mx-1" onClick={()=>po_statusAllData()}>View</Button>
                            <Button  size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47'}} className="btn btn-sm btn-primary" onClick={()=>ExporttoExcelConsolidate()}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                             <Button size='md' className="mx-1 w-lg" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{po_statusAllData()}}>View</Button>
                          <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47',fontWeight:'bolder'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button>
                        </Col>
                    </Row>
                    {showtabel && (
                    <div className="mt-3">
                        <TableContainer
                            columns={column}
                            data={po_statusdata}
                            isGlobalFilter={true}
                            isAddTableBorderStrap={true}
                            //   handleInvoiceClicks={handleInvoiceClicks}
                        />
                    </div>
                    )}

                </CardBody>
            </Card>
            <Modal isOpen={modal} toggle={toggle} size="xl" style={{backgroundColor:'white'}}>
              <ModalHeader toggle={toggle}>
                {po_header.map((i, index)=>(
                    <div key={index}>
                        <h2>Purchase Status For <span>{i.style} / {i.artNo}</span></h2>
                    </div>
                ))}
              </ModalHeader>
              <ModalBody>
                <div>
                    {po_header.map((i, index)=>(
                    <table key={index} className="table table-bordered border-dark w-75 p-2" rules="all">
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px'}}>Company</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.company}</td>
                                <th style={{border:'1px solid black',padding:'5px'}}>IPO No/Date</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.ipoNo} / {i.ipoDt}</td>
                            </tr>
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px'}}>Buyer</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.buyer}</td>
                                <th style={{border:'1px solid black',padding:'5px'}}>Season</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.season}</td>
                            </tr>
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px'}}>Order No</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.orderId}</td>
                                <th style={{border:'1px solid black',padding:'5px'}}>Order Date</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.orderDt}</td>
                            </tr>
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px'}}>Style/Art</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.style} / {i.artNo}</td>
                                <th style={{border:'1px solid black',padding:'5px'}}>Quantity</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.qty}</td>
                            </tr>
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px'}}>Garment Description</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.garment}</td>
                                <th style={{border:'1px solid black',padding:'5px'}}>Ship Date</th>
                                <td style={{border:'1px solid black',padding:'5px'}}>{i.shipDt}</td>
                            </tr>
                    </table>
                    ))}
                    {po_fabric != "" ? <div className="mt-5">      
                        <div>
                            <h3 className="text-center">Fabric Status</h3>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-dark">
                                <thead>
                                    <tr style={{backgroundColor:'#11244c',color:'white',border:'white'}}>
                                        <th>PO No</th>
                                        <th>PO Date</th>
                                        <th>Delivery Date</th>
                                        <th>Supplier</th>
                                        <th>Item Code</th>
                                        <th>Fabric type</th>
                                        <th>Content</th>
                                        <th>Reference</th>
                                        <th>Color/Design</th>
                                        <th>Fabric Width</th>
                                        <th>CntCns</th>
                                        <th>Ordered</th>
                                        <th>Received</th>
                                        <th>Balance</th>
                                        <th>QC Pass</th>
                                        <th>Rate</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {po_fabric.map((i, index)=>(
                                        <tr key={index} className="text-nowrap">
                                            <td>{i.poNo}</td>
                                            <td>{i.poDate}</td>
                                            <td>{i.delDate}</td>
                                            <td>{i.supplier}</td>
                                            <td>{i.itemCode}</td>
                                            <td>{i.itemType}</td>
                                            <td>{i.content}</td>
                                            <td>{i.reference}</td>
                                            <td>{i.color_Pattern}</td>
                                            <td>{i.width}</td>
                                            <td>{i.counts}</td>
                                            <td>{i.ord}</td>
                                            <td>{i.recd}</td>
                                            <td>{i.bal}</td>
                                            <td>{i.qc}</td>
                                            <td>{i.pRate}</td>
                                            <td><Numeral value={i.amount} format={"0,0.00"}/></td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan='15'></td>
                                        <th>Total</th>
                                        <td><Numeral value={fabtotal} format={"0,0.00"}/></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> : null }
                    {po_trim != "" ? <div className="mt-5">      
                        <div>
                            <h3 className="text-center">Trim Status</h3>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-dark">
                                <thead>
                                    <tr style={{backgroundColor:'#11244c',color:'white',border:'white'}}>
                                        <th>PO No</th>
                                        <th>PO Date</th>
                                        <th>Delivery Date</th>
                                        <th>Supplier</th>
                                        <th>Item Code</th>
                                        <th>Item Desc</th>
                                        <th>Reference</th>
                                        <th>Content</th>
                                        <th>It/G Color</th>
                                        <th>It/Gr Size</th>
                                        <th>Style</th>
                                        <th>Po_Raised</th>
                                        <th>Received</th>
                                        <th>Balance</th>
                                        <th>QC Pass</th>
                                        <th>Rate</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {po_trim.map((i, index)=>(
                                        <tr key={index} className="text-nowrap">
                                            <td>{i.poNo}</td>
                                            <td>{i.poDate}</td>
                                            <td>{i.delDate}</td>
                                            <td>{i.supplier}</td>
                                            <td>{i.itemCode}</td>
                                            <td>{i.item}</td>
                                            <td>{i.reference}</td>
                                            <td>{i.content}</td>
                                            <td>{i.color}</td>
                                            <td>{i.sizes}</td>
                                            <td></td>
                                            <td>{i.ord}</td>
                                            <td>{i.recd}</td>
                                            <td>{i.bal}</td>
                                            <td>{i.qc}</td>
                                            <td>{i.pRate}</td>
                                            <td><Numeral value={i.amount} format={"0,0.00"}/></td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan='15'></td>
                                        <th>Total</th>
                                        <td><Numeral value={trimtotal} format={"0,0.00"}/></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> : null }
                </div>
              </ModalBody>
           </Modal>
        </Container>

        {po_statusNull ? (
              <SweetAlert
                title="No Data Found"
                timeout={2000}
                style={{
                  position: "absolute",
                    justifyContent:'center',
                    alignItems:'center'
                }}
                showCloseButton={false}
                showConfirm={false}
                warning
                onConfirm={() => {
                  setpo_statusNull(false);
                }}
              ></SweetAlert>
            ) : null}

      </div>
            {/* </div>
        </div>
    </div> */}
    </React.Fragment>
  )
}

export default PO_Status